'use client'

import { pageListAnalyticsAtom } from '@/feature/product/services/product.store'
import { useSetAtom } from 'jotai'
import { useEffect } from 'react'

type SearchPageAnalyticsProps = {
  title: string
}

export function SearchPageAnalytics({ title }: SearchPageAnalyticsProps) {
  const setPageListAnalytics = useSetAtom(pageListAnalyticsAtom)

  useEffect(() => {
    setPageListAnalytics({ title })
  }, [title, setPageListAnalytics])

  return null
}
